(function () {
  document.querySelectorAll('.dw-gallery').forEach(initGallery);

  function initGallery(gallery) {
    var initialCount = parseInt(gallery.dataset.initialCount, 10) || 40;
    var batchSize = parseInt(gallery.dataset.batchSize, 10) || 20;
    var chips = gallery.querySelectorAll('.dw-gallery__chip');
    var tiles = Array.prototype.slice.call(gallery.querySelectorAll('.dw-gallery__tile'));
    var loadMoreBtn = gallery.querySelector('.dw-gallery__load-more');
    var emptyMsg = gallery.querySelector('.dw-gallery__empty');

    var currentFilter = 'all';
    var visibleCount = initialCount;

    function matchesFilter(tile) {
      return currentFilter === 'all' || tile.dataset.tag === currentFilter;
    }

    function render() {
      var matched = tiles.filter(matchesFilter);

      tiles.forEach(function (tile) {
        if (!matchesFilter(tile)) {
          tile.hidden = true;
        }
      });

      matched.forEach(function (tile, i) {
        tile.hidden = i >= visibleCount;
      });

      if (loadMoreBtn) {
        loadMoreBtn.hidden = matched.length <= visibleCount;
      }
      if (emptyMsg) {
        emptyMsg.hidden = matched.length > 0;
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) {
          c.classList.remove('is-active');
        });
        chip.classList.add('is-active');
        currentFilter = chip.dataset.filter;
        visibleCount = initialCount;
        render();
      });
    });

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        visibleCount += batchSize;
        render();
      });
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        openLightbox(tile);
      });
    });

    render();
  }

  var lightbox = document.querySelector('.dw-lightbox');
  var lbImg, lbPoster, lbSize, lbLink, lbClose;

  if (lightbox) {
    lbImg = lightbox.querySelector('.dw-lightbox__img');
    lbPoster = lightbox.querySelector('.dw-lightbox__poster');
    lbSize = lightbox.querySelector('.dw-lightbox__size');
    lbLink = lightbox.querySelector('.dw-lightbox__link');
    lbClose = lightbox.querySelector('.dw-lightbox__close');

    lbClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }

  function openLightbox(tile) {
    if (!lightbox) return;
    var imgEl = tile.querySelector('img');
    var full = tile.dataset.full || (imgEl ? imgEl.src : '');
    var poster = tile.dataset.poster || '';
    var link = tile.dataset.link || '';
    var sizeEl = tile.querySelector('.dw-gallery__size');

    lbImg.src = full;
    lbImg.alt = poster;
    lbPoster.textContent = poster;

    // サイズ情報（あれば表示）
    if (lbSize) {
      if (sizeEl) {
        lbSize.innerHTML = sizeEl.innerHTML;
        lbSize.hidden = false;
        lightbox.classList.add('has-size');
      } else {
        lbSize.innerHTML = '';
        lbSize.hidden = true;
        lightbox.classList.remove('has-size');
      }
    }

    if (link) {
      lbLink.href = link;
      lbLink.hidden = false;
    } else {
      lbLink.hidden = true;
    }

    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    lbImg.src = '';
    document.body.style.overflow = '';
  }
})();